import React, { useRef, useState } from 'react'
import { Close, FeedbackIcon } from '../Icon'
import { Flex } from '../Flex'
import ReCAPTCHA from 'react-google-recaptcha'
import { EngagementEvents, logCrmEvent } from '../../utils/crmEvents'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../store'
import { showBanner } from '../../../global-state/banner-slice'
import { P } from '../P'
import { InvestorFeedbackWidgetForm } from './investor-feedback-widget-form'
import './investor-feedback-widget.scss'
import { feedbackSchema } from '../../utils/schema'
import { InvestorFeedbackFormProps } from '../../types'

const InvestorFeedbackWidget = () => {
  const { authToken } = useSelector((state: RootState) => state.investor)
  const dispatch = useDispatch()
  const [isWidgetOpen, setIsWidgetOpen] = useState(false)
  const [captchaToken, setCaptchaToken] = useState<string | null>(null)
  const reRef = useRef<ReCAPTCHA>(null)
  const [initialValues] = useState<InvestorFeedbackFormProps>({
    description: '',
  })

  const handleFeedbackSubmit = async (values: InvestorFeedbackFormProps) => {
    const data = await logCrmEvent(
      EngagementEvents.INVESTOR_FEEDBACK,
      {
        Authorization: authToken ?? '',
      },
      {
        feedback: values.description,
      },
    )
    if (data?.status === 200) {
      dispatch(
        showBanner({
          text: 'Your feedback has been submitted successfully',
          variant: 'success-banner',
          duration: 5000,
        }),
      )
      setTimeout(() => {
        setIsWidgetOpen(false)
      }, 100)
    } else {
      dispatch(
        showBanner({
          text: 'There was some problem submitting your feedback. Please try again later',
          variant: 'error-banner',
          duration: 5000,
        }),
      )
    }
  }

  return !isWidgetOpen ? (
    <>
      <div
        className='investor-feedback-widget-icon-container'
        data-testid='investor-feedback-widget-icon-container'
      >
        <div className='investor-feedback-widget-icon'>
          <FeedbackIcon />
        </div>
        <div
          className='investor-feedback-widget-button'
          onClick={() => setIsWidgetOpen(true)}
          data-testid='investor-feedback-widget-button'
        >
          Share your Feedback
        </div>
      </div>
    </>
  ) : (
    <div className='investor-feedback-widget' data-testid='investor-feedback-widget-form'>
      <Flex variant='space-between' classes={['investor-feedback-widget__header', 'align-center']}>
        <P text='Feedback' textSize='regular' classes={['text-white', 'bold']} />
        <Close
          width='16px'
          height='16px'
          type='white'
          onClick={() => setIsWidgetOpen(false)}
          classes={['investor-feedback-widget__header__close']}
        />
      </Flex>
      <InvestorFeedbackWidgetForm
        captchaToken={captchaToken}
        setCaptchaToken={setCaptchaToken}
        reRef={reRef}
        initialValues={initialValues}
        validationSchema={feedbackSchema}
        handleSubmit={handleFeedbackSubmit}
      />
    </div>
  )
}

export { InvestorFeedbackWidget }
